/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DrawerIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <rect x="0.5" y="0.5" width="23" height="23" />
      <rect x="2.5" y="2.5" width="8" height="5" />
      <rect x="13.5" y="2.5" width="8" height="5" />
      <rect x="2.5" y="9.5" width="8" height="5" />
      <rect x="13.5" y="9.5" width="8" height="5" />
      <rect x="2.5" y="16.5" width="8" height="5" />
      <rect x="13.5" y="16.5" width="8" height="5" />
      <rect x="16.5" y="2.5" width="2" height="2" />
      <rect x="5.5" y="2.5" width="2" height="2" />
      <rect x="16.5" y="16.5" width="2" height="2" />
      <rect x="5.5" y="16.5" width="2" height="2" />
      <rect x="5.5" y="9.5" width="2" height="2" />
      <rect x="16.5" y="9.5" width="2" height="2" />
    </g>
  </svg>
);

export default DrawerIcon;
